import config from "./config";
var axios = config();

export default {
  getSemesterTotals(termId, termEndId) {
    return axios.get(
      "/api/OpportunityReports/SemesterTotals?" +
        (termId ? "&termId=" + termId : "") +
        (termEndId ? "&endTermId=" + termEndId : "")
    );
  },
  getSiteOpportunityTotals(siteId) {
    return axios.get(
      "/api/OpportunityReports/SiteOpportunities?siteid=" + siteId
    );
  },
  getIncompleteOpportunities() {
    return axios.get("/api/OpportunityReports/IncompleteOpportunities");
  },
  getStudentOpportunityTimeline(termId) {
    return axios.get(
      "/api/OpportunityReports/StudentOpportunityTimeline?termId=" + termId
    );
  },
  getStudentOpportunitySiteCounts(siteId) {
    return axios.get(
      "/api/OpportunityReports/StudentOpportunitySiteCounts?siteid=" + siteId
    );
  },
  getSitesPerSemester() {
    return axios.get("/api/OpportunityReports/SitesPerSemester");
  },
  getSitePopularity(termId, limit) {
    var request = "/api/OpportunityReports/SitePopularity?";
    if (termId) {
      request += "&termId=" + termId;
    }
    if (limit) {
      request += "&limit=" + limit;
    }
    return axios.get(request);
  }
};
